module.exports = __webpack_public_path__ + "img/2018-04-27.7e2635ff.jpg";